module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ4AAAEOAQAAAABQysQIAAABHElEQVR4Ae3WAcZDQQwE4OEdYI/Uq++R3gGW+TXmSX5QOgXM4OluPrCpCPgpJ8QgGwp5X+ReB3jxQFkWCVndilN3KlS2SULOaEXfzWOIT3gDeKkVIb8mLHexXMhvCNnVQSohJoFSx/4oIRbp7HKoCdIJcUgXUPvaDdSQrmqIT3og6+33XNpCHLKoKqDR3AsGEGKSgyoI39doQLmQL4mqD675fBGVNwZWiEX4OCwSwMXZFIeE6NjToneLOlok5P/c6KruaJCQiSkH5SJpkZCO3p4Eekgvh4RsKGM5VsEnIYvvPHevG2PB4DZJyEG3QgVUugE2CSHr19yLSbokpBsgMj4eCZnDo1wVNEtokRAoTwP0H38WDIeEfMr3JOQPnzIG9Rb+b5cAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr2.png
// module id = 926
// module chunks = 32